import { useRef, useEffect, useState } from "react"
import TeamMemberBuilder from "../../components/TeamMemberBuilder/Index"
import { useNavigate, useParams } from "react-router-dom"
import { fetchAdminCompetition } from "../../api/admin/api"
import { fetchCompetitionTeam } from "../../api/api"

export default function CreateTeamMembers() {
  const { competition_id, competition_event_id, competition_team_id, editing } = useParams()
  const [competition, setCompetition] = useState(null)
  const [competitionTeam, setCompetitionTeam] = useState(null)
  const hasDeactivated = useRef(false);
  const navigate = useNavigate()
  
  useEffect(() => {
    fetchAdminCompetition(competition_id).then(res => setCompetition(res))
    fetchCompetitionTeam(competition_team_id).then(res => setCompetitionTeam(res))

    const handleBackButtonPressed = (event) => {
      // Don't allow them to leave the page. Force them to hit the submit
      const confirmLeave = window.confirm(
        "Are you sure you want to leave? Your team will remain removed from the google sheet. You must click `submit` to readd the team to the google sheet. Hit cancel to remain on the current page."
      );

      if (!confirmLeave) {
        // Cancel back navigation
        navigate(1)// Hacky way to cancel back nav and "stay" on page
      }
    }

    window.addEventListener('popstate', handleBackButtonPressed)

    return () => {
      window.removeEventListener('popstate', handleBackButtonPressed)
    }
  }, [])

  const afterActivate = () => {
    navigate(`/admin/competition_events/${competition_event_id}`)
  }

  return (
    <>
      {competition && competitionTeam ? 
      <TeamMemberBuilder
        competition={competition}
        team={competitionTeam}
        competition_event_id={competition_event_id}
        afterActivate={afterActivate}
      />
      : <p>Loading...</p>}
    </>
  )
}